import React, { useContext } from 'react'

import { Trans, useTranslation } from 'react-i18next'

import Dialog from '@components/shared/Dialog'
import { TitleContext } from '@providers/TitleProvider'
import { useDialogStore } from '@stores/dialog.store'
import PageRoutes from '@utils/page-routes'

const EditScoreDetailsDialog: React.FC = () => {
  const { t } = useTranslation()
  const { title } = useContext(TitleContext)
  const closeDialog = useDialogStore((s) => s.closeDialog)

  const product = title.product
  if (!product) {
    // this should never happen
    console.warn('Product missing!')
    return null
  }

  return (
    <Dialog name="edit_score_details" title={t('action.editScore')} maxWidth={410}>
      <p>
        <Trans i18nKey="messages.editScoreDetails" />
      </p>
      <div className="flex flex-row w-full justify-end mt-4">
        <button
          title={t('action.cancel')}
          onClick={() => closeDialog('edit_score_details')}
          className="btn btn-secondary ml-3">
          {t('action.cancel')}
        </button>
        <a
          title={t('action.editScore')}
          href={PageRoutes.musicEditing(title, false)}
          className="btn btn-primary ml-3">
          {t('action.editScore')}
        </a>
      </div>
    </Dialog>
  )
}

export default EditScoreDetailsDialog
